import {Edit} from '@material-ui/icons';
import React from 'react';

export function EditIcon() {
  return <Edit fontSize="small" color="primary" />;
}
